 // document.addEventListener('DOMContentLoaded', function () {
 //    const input = document.getElementById('97674-text-1');
 //    if (input) {
 //      input.addEventListener('input', function () {
 //        this.value = this.value.replace(/[^A-Za-z\s]/g, '');
 //      });
 //    }
 //  });




//  document.addEventListener('DOMContentLoaded', function () {
//   const input = document.getElementById('97674-text-1');
//   if (input) {
//     input.addEventListener('keypress', function (e) {
//       const char = String.fromCharCode(e.which);
//       if (!/^[A-Za-z\s]$/.test(char)) {
//         e.preventDefault(); // block the key
//       }
//     });
//   }
// });



 window.onload = function () {
    const input = document.getElementById('97674-text-1');

    if (input) {
      // Block typing of anything except A–Z, a–z, space
      input.addEventListener('keydown', function (e) {
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
        const key = e.key;

        if (!/^[a-zA-Z ]$/.test(key) && !allowedKeys.includes(key)) {
          e.preventDefault();
        }
      });

      // Block pasting invalid content
      input.addEventListener('paste', function (e) {
        const paste = e.clipboardData.getData('text');
        if (/[^A-Za-z\s]/.test(paste)) {
          e.preventDefault();
        }
      });
    } else {
      console.warn('❗ Input field with ID "97674-text-1" not found.');
    }
  };